import { render } from "./FrontPage.vue?vue&type=template&id=a2f358e4&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=ts"
export * from "./FrontPage.vue?vue&type=script&lang=ts"

import "./FrontPage.vue?vue&type=style&index=0&id=a2f358e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2f358e4"
/* hot reload */
if (module.hot) {
  script.__hmrId = "a2f358e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2f358e4', script)) {
    api.reload('a2f358e4', script)
  }
  
  module.hot.accept("./FrontPage.vue?vue&type=template&id=a2f358e4&scoped=true", () => {
    api.rerender('a2f358e4', render)
  })

}

script.__file = "src/views/FrontPage.vue"

export default script